import { render, staticRenderFns } from "./unauthorized.html?vue&type=template&id=740d3d8a&scoped=true&"
import script from "./unauthorized.js?vue&type=script&lang=js&"
export * from "./unauthorized.js?vue&type=script&lang=js&"
import style0 from "./unauthorized.scss?vue&type=style&index=0&id=740d3d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d3d8a",
  null
  
)

export default component.exports